import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'bundles/apex/deals/tagged_body/tag/tooltip';

import './styles.scss';

export default function Tag({ props: [tag, tagify] }) {
  // NOTE: The tooltip *must* be wrapped inside of the tag itself in order to work inside an input,
  //       as tagify.js:2340 tries to "help" by removing wrapping elements around tag divs

  // HACK: Include "jsxRuntime" somewhere in the string representation of this function in a way
  //       that won't be stripped out during minification to force tagify to recognize this function
  //       as a React component, because we're on an older version of React DOM than Tagify expects.
  //       See https://github.com/yairEO/tagify/blob/71b8c8ec2e1325c090687c5e74fcde666cdd021e/src/react.tagify.jsx#L18
  return (
    <div
      aria-label={tag.label}
      className={`jsxRuntime ${tagify.settings.classNames.tag} deal-tagged-body-tag`}
      contentEditable={false}
    >
      <div>
        <span className={tagify.settings.classNames.tagText}>
          {tag.label}
        </span>
      </div>

      <Tooltip tag={tag} />
    </div>
  );
}

Tag.propTypes = {
  props: PropTypes.array.isRequired,
};
